export class DateService {
    constructor($filter) {
        'ngInject';

        this.$filter = $filter;
    }

    getFormattedTime(time) {
        const isMinutesZero = new Date(time).getMinutes() === 0 ? true : false;
        return isMinutesZero ? this.$filter('date')(time, 'h a') : this.$filter('date')(time, 'h:mm a');
    }

    parseDateFromServerDate(date) {
        if (date) {
            let utcdate = new Date(date);
            let timeOffset = utcdate.getTimezoneOffset() * 60 * 1000;
            let time = utcdate.getTime() + timeOffset;
            utcdate = new Date(time);
            return utcdate;
        }
        return null;
    }

    parseDateToServerDate(dateObj, hour = 0, minute = 0) {
        return new Date(Date.UTC(dateObj.values.year, dateObj.values.month, dateObj.values.day, hour, minute, 0)).toISOString();
    }

    convertDateToLocal(date) {
        if (date) {
            return new Date(date);
        }
        return null;
    }

    convertDate(date) {
        if (date) {
            return new Date(date).toISOString();
        }
        return null;
    }

    //To get current date or parse the given string to date
    getDate(date = new Date()) {
        let dateObj = {};
        if (typeof date === 'string') {
            dateObj.date = new Date(date);
            dateObj.values = this.getDateDetailsObject(dateObj.date);
            return dateObj;
        }
        dateObj.date = (date) ? new Date(date) : NaN;
        dateObj.values = this.getDateDetailsObject(dateObj.date);
        return dateObj;
    }

    //resetTime
    resetTime(date = new Date(), reset = false) {
        let _dateObj = this.getDate(date);
        let _hour = (reset) ? 0 : _dateObj.values.hour;
        let _minute = (reset) ? 0 : _dateObj.values.minute;

        return this.parseDateToServerDate(_dateObj, _hour, _minute);
    }

    resetDateTimeWithOtherTime(date = new Date(), time = new Date(), reset = false) {
        let _dateObj = this.getDate(date);
        let _timeObj = this.getDate(time);
        let _hour = (reset) ? 0 : _timeObj.values.hour;
        let _minute = (reset) ? 0 : _timeObj.values.minute;

        return this.parseDateToServerDate(_dateObj, _hour, _minute);
    }

    //get day, month and fullyear from given date
    getDateDetailsObject(date) {
        return {
            day: (date) ? date.getDate() : NaN,
            month: (date) ? date.getMonth() : NaN,
            year: (date) ? date.getFullYear() : NaN,
            hour: (date) ? date.getHours() : NaN,
            minute: (date) ? date.getMinutes() : NaN,
            sec: (date) ? date.getSeconds() : NaN,
            msec: (date) ? date.getMilliseconds() : NaN,
            dayId: (date) ? date.getDay() : NaN
        };
    }

    //To get difference between two dates
    getDateDifference(startDate = new Date(), endDate = new Date()) {
        startDate = new Date(new Date(this.getDate(startDate).date).setHours(0, 0, 0, 0));
        endDate = new Date(new Date(this.getDate(endDate).date).setHours(0, 0, 0, 0));

        let timeDiff = Math.abs(endDate.getTime() - startDate.getTime());
        let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        return diffDays
    }

    //add days and return new Date
    addDays(date = new Date(), additionalDays) {
        date = this.getDate(date).date;
        return new Date(date.setDate(date.getDate() + additionalDays));
    }

    //check given date is same or old
    isSameOrBefore(startDate = new Date(), endDate = new Date()) {
        startDate = this.getDate(startDate).date;
        endDate = this.getDate(endDate).date;

        return endDate <= startDate;
    }

    //check given dates are same or not
    isSame(startDate = new Date(), endDate = new Date()) {
        startDate = new Date(startDate);
        endDate = new Date(endDate);

        return startDate.getTime() === endDate.getTime();
    }

    //change the year
    changeYear(date = new Date(), newYear) {
        date = this.getDate(date).date;
        return new Date(date.setFullYear(newYear));
    }

    //change the month
    changeMonth(date = new Date(), newMonth) {
        date = this.getDate(date).date;
        return new Date(date.setMonth(newMonth));
    }

    //change the date
    changeDate(date = new Date(), newDate) {
        date = this.getDate(date).date;
        return new Date(date.setDate(newDate));
    }

    //change Hours
    changeHours(date = new Date(), newHours = 0) {
        date = this.getDate(date).date;
        return new Date(date.setHours(newHours));
    }

    //change Minutes
    changeMinutes(date = new Date(), newMinutes = 0) {
        date = this.getDate(date).date;
        return new Date(date.setMinutes(newMinutes));
    }

    //get all sundays of the month
    getAllSundays(date = new Date()) {
        let d = new Date(date);
        let getTot = daysInMonth(d.getMonth(), d.getFullYear()); //Get total days in a month
        let sun = new Array();   //Declaring array for inserting Sundays

        for (let i = 1; i <= getTot; i++) {    //looping through days in month
            let newDate = new Date(d.getFullYear(), d.getMonth(), i)
            if (newDate.getDay() == 0) {   //if Sunday
                sun.push(newDate);
            }
        }
        function daysInMonth(month, year) {
            return new Date(year, month + 1, 0).getDate();
        }
        return sun;
    }

    //find All Sundays by given month and year
    getAllSundaysByMonth(month, year) {
        let d = month + "/1/" + year;
        let date = new Date(d);
        return this.getAllSundays(date);
    }

    //get start Date Of Week
    getStartDateOfWeek(date = new Date()) {
        date = this.getDate(date);
        let currentSundays = this.getAllSundaysByMonth(date.values.month + 1, date.values.year);
        if (currentSundays[0].getDate() === 1) {
            return this.getDate(currentSundays[0]);
        } else {
            let month = (date.values.month === 0) ? 12 : date.values.month;
            let year = (date.values.month === 0) ? date.values.year - 1 : date.values.year;
            let previousSundays = this.getAllSundaysByMonth(month, year);
            return this.getDate(previousSundays[previousSundays.length - 1]);
        }
    }

    //get next sunday
    getNextSunday(date = new Date()) {
        date = this.getDate(date);
        let nextSunday = new Date(date.date.getFullYear(), date.date.getMonth(), date.date.getDate() + (7 - date.date.getDay()));
        return this.getDate(nextSunday);
    }

    //get first day of the given month
    getFirstDayOfMonth(month, year) {
        let d = month + "/01/" + year;
        let date = new Date(d);
        return this.getDate(date);
    }

    convertSecondsToHoursAndMinute(seconds) {
        seconds = Number(seconds);
        const hour = Math.floor(seconds / 3600);
        const minute = Math.floor(seconds % 3600 / 60);

        const hoursDetails = hour > 0 ? hour + (hour === 1 ? ' hour ' : ' hours ') : '';
        const minutesDetails = minute > 0 ? minute + (minute === 1 ? ' minute' : ' minutes') : '';
        return `${hoursDetails} ${minutesDetails}`;
    }
}


// WEBPACK FOOTER //
// ./src/app/common/libs/date/date.service.js